import { useEffect, useState } from "react"
import { API_STATUS } from "../../constants"
import { UserNotificationsApi } from "../../apis/notification/user_note_api";
import { NoteReadApi } from "../../apis/notification/note_read_api";
import PlaceHolder from "../../utils/placeholder";
import GetTime from "../../utils/gettime";
import { Link, useNavigate } from "react-router-dom";

export default function NotificationList({ setMncount }) {
    const navigate = useNavigate();
    const [getNoteApi, setGetNoteApi] = useState(API_STATUS);
    
    const [noteData, setNoteData] = useState([]);

    useEffect(() => {
        UserNotificationsApi(setGetNoteApi);
    }, []);

    useEffect(() => {
        if (!getNoteApi.isLoader && !getNoteApi.isError && getNoteApi.data != null) {
            
            if (getNoteApi.data.status === 1) {
                setNoteData(getNoteApi.data.data);
            }
        }
    }, [getNoteApi]);

    const note_route = (item) => {
        if (item.un_type === 'Post') {
            // navigate('/post_id/'+item.un_note_id);
            window.location.href = '/post_id/' + item.un_note_id;
        }
        if (item.un_type === 'Contact_Request') {
            navigate('/contact_request');
        }
        if (item.un_type === 'Event') {
            window.location.href = '/event_details/' + item.un_note_id;
           // navigate('/event_details/'+item.un_note_id);
        }
        if (item.un_type === 'Approach') {
            navigate('/approach_details/' + item.un_note_id);
        }
        if (item.un_type === 'Approach_Message') {
            navigate('/approach_details/' + item.un_note_id+'/true');
        }
    }

    return <div className="sm:w-[397px] w-full bg-white shadow-lg md:!left-[73px] hidden !left-0 dark:bg-dark2 dark:border1 max-md:bottom-[57px]" uk-drop="pos: left-center;animate-out: true; animation: uk-animation-slide-left-medium ; mode:click">
        <div className="md:h-screen overflow-y-auto h-[calc(100vh-120px)]">

            <div className="flex items-center justify-between px-5 py-4 mt-3">
                <h3 className="md:text-xl text-lg font-medium mt-3 text-black dark:text-white">Notification</h3>

            </div>

            {
                getNoteApi.isLoader &&
                <PlaceHolder />
            }

            <div className="px-2 -mt-2 text-sm font-normal">

                <div className="px-5 py-3 -mx-2">
                    <h4 className="font-semibold">New</h4>
                </div>
                {
                    noteData.map((item, i) =>
                        <div key={i}>
                            {
                                item.un_view === 0 &&
                                <Link key={i} onClick={() => {
                                    note_route(item);
                                }} className="relative flex items-center gap-3 p-2 duration-200 rounded-xl hover:bg-secondery">
                                    <div className="relative w-12 h-12 shrink-0"> <img src={item.user_pic} alt="" className="object-cover w-full h-full rounded-full" /></div>
                                    <div className="flex-1 ">
                                        <p> <b className="font-bold mr-1"> {item.username}</b> {item.un_body}</p>
                                        <div className="text-xs text-gray-500 mt-1.5 dark:text-white/80"> {GetTime(item.un_date)} </div>
                                    </div>
                                </Link>
                            }
                        </div>
                    )
                }

                <div class="border-t px-5 py-3 -mx-2 mt-4 dark:border-slate-700/40">
                    <h4 class="font-semibold"></h4>
                </div>

                {
                    noteData.map((item, i) =>
                        <div key={i}>
                            {
                                item.un_view === 1 &&
                                <Link key={i} onClick={() => {
                                    note_route(item);
                                }} className="relative flex items-center gap-3 p-2 duration-200 rounded-xl hover:bg-secondery">
                                    <div className="relative w-12 h-12 shrink-0"> <img src={item.user_pic} alt="" className="object-cover w-full h-full rounded-full" /></div>
                                    <div className="flex-1 ">
                                        <p> <b className="font-bold mr-1"> {item.username}</b> {item.un_body}</p>
                                        <div className="text-xs text-gray-500 mt-1.5 dark:text-white/80"> {GetTime(item.un_date)} </div>
                                    </div>
                                </Link>
                            }
                        </div>
                    )
                }

            </div>

        </div>
    </div>
}